/** Store badges in `public/badges/` — same artwork as band-space-landing */

export const GOOGLE_PLAY_BADGE_SRC = '/badges/google-play-dark.svg';
export const APP_STORE_BADGE_SRC = '/badges/app-store-dark.svg';

export const STORE_MARKETING_BADGE_HEIGHT = { xs: 52, sm: 48 } as const;
